<template>
  <div class="layout-container">
    <el-row>
      <el-col>
        <HeaderBar />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4" v-if="!($router.history.current.name === 'takingExam')"><SideMenuItem /></el-col>
      <el-col :span="$router.history.current.name === 'takingExam' ? 24 : 20" style="margin-top: 20px; padding: 0 20px">
        <router-view></router-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HeaderBar from "@/layouts/HeaderBar.vue";
import SideMenuItem from "@/layouts/SideMenuItem.vue";
export default {
  components: {
    HeaderBar,
    SideMenuItem,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100vh;
}
</style>
